import { LandingData } from "@/types/types";
import styled from "styled-components";
import { MaxWidthContainer as ParentMaxWidthContainer } from "../styles";
import { H2 } from "@/components/ui/typography";
import { mobile } from "@/theme/common";
import { Item } from "../Item";
import { ButtonOutline } from "@/components/ui/buttons";

/**
 * Types
 */

interface PrizeDetailData {
  data: LandingData["sections"]["prizeDetails"];
  handleRedirectToTermsAndConditions: () => void;
}

/**
 * Styled Components
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 0;
  ${mobile(`
    padding: 40px 16px;
  `)}
`;

const MaxWidthContainer = styled(ParentMaxWidthContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

const Title = styled(H2)`
  text-align: center;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const Button = styled(ButtonOutline)`
  && {
    height: 48px;
    border-radius: 12px;
  }
`;

/**
 * HowToPlaySection Component
 */

export const PrizeDetailSection = ({
  data,
  handleRedirectToTermsAndConditions,
}: PrizeDetailData) => {
  if (!data) {
    return null;
  }

  const { title, details, buttonText } = data;
  return (
    <Container>
      <MaxWidthContainer>
        <Title
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <ItemsContainer>
          {details.map((detail) => (
            <Item key={detail.title} {...detail} />
          ))}
        </ItemsContainer>
        <Button
          text={buttonText}
          onClick={handleRedirectToTermsAndConditions}
        />
      </MaxWidthContainer>
    </Container>
  );
};
